<template>
  <portfolio-page
      art-board-image="/img/cover-05.png"
      art-board-url="https://www.northlinkferries.co.uk"
      page-title="Northlink Ferries"
  >
    <template v-slot:info-content>
      <h3 class="max-w-3xl mx-auto text-balance text-3xl font-semibold tracking-tight text-gray-700 mb-14">
        LG WebOS VOD System
      </h3>

      <p class="text-xl text-gray-700 max-w-3xl mx-auto mb-14">
        coming soon...
      </p>
    </template>
    <template v-slot:level-up-content>
      <ul class="list-image-starG list-inside">
        <li class="leading-10">Vue JS</li>
        <li class="leading-10">LG webOS</li>
      </ul>
    </template>
  </portfolio-page>
</template>

<script>
import PortfolioPage from "@/components/PortfolioContainer.vue";

export default {
  components: {
    PortfolioPage,
  }
}
</script>
